import BundleDetailsStep from './BundleDetails/BundleDetailsStep';
import BundlePricingStep from './BundlePricing/BundlePricingStep';
import BundleMechanicalRulesStep from './BundleMechanicalRules/MechanicalRulesStep';
import BundleSummaryStep from './BundleSummary/BundleSummaryStep';
import { LOT_OPTIONS } from '../CreateActivityAndPricing/ActivityItemPricing/ActivityItemPricingConsts';

export const CREATE_BUNDLE_STEP_KEYS = {
    BUNDLE_DETAILS: 'bundleDetails',
    PRICING: 'pricing',
    RULES: 'rules',
    SUMMARY: 'summary'
};

export const BUNDLE_STEP_CLEANUP_CONFIG = {
    [CREATE_BUNDLE_STEP_KEYS.PRICING]: {
        listKey: 'pricingItems',
        editingKey: 'editingPricingKeys',
        unsavedFlag: 'somePricingHasUnsavedEdits'
    },
    [CREATE_BUNDLE_STEP_KEYS.RULES]: {
        listKey: 'rulesList',
        editingKey: 'editingRuleKeys',
        unsavedFlag: 'someRuleHasUnsavedEdits'
    }
};

export const CREATE_BUNDLE_STEP_INDEX = {
    BUNDLE_DETAILS: 0,
    PRICING: 1,
    RULES: 2
};

export const CREATE_BUNDLE_STEP_WARNINGS = {
    PRICING_EDITING: "You're currently editing a pricing configuration. Click 'Done' to save your changes, or they will be lost.",
    NO_PRICING_CONFIGURED: 'No pricing configured yet, please configure at least one.',
    RULE_EDITING: "You're currently editing a rule. Click 'Done' to save your changes, or they will be lost.",
    NO_RULES_CONFIGURED: 'No automation rules configured yet.',
    MISSING_FIELDS: 'There are some missing fields. Please complete them in order to save this step.',
    BUNDLE_DETAILS_REQUIRED: 'Bundle name and at least 2 activities are required.',
    DUPLICATE_NAME: 'A bundle with this name already exists. Please use a different name.',
};

export const buildCreateBundleValidationData = (steps = {}) => ({
    bundleDetails: steps['bundleDetails'] || {},
    pricing: steps['pricing'] || {},
    rules: steps['rules'] || {}
});

export const CREATE_BUNDLE_STEPS = [
    {
        key: 1,
        stepKey: 'bundleDetails',
        title: 'Bundle',
        subtitle: 'Define the bundle',
        component: () => <BundleDetailsStep />,
        validate: (data) =>
            data.bundleDetails?.name && data.bundleDetails.name.trim() !== '' &&
            (data.bundleDetails?.activityItemIds?.length || 0) >= 2 &&
            !data.bundleDetails?.nameIsAlreadyTaken
    },
    {
        key: 2,
        stepKey: 'pricing',
        title: 'Pricing',
        subtitle: 'Set up pricing',
        component: () => <BundlePricingStep />,
        validate: (data) =>
            data.pricing?.pricingItems?.length > 0 &&
            data.pricing.pricingItems.every(item =>
                item.clientId &&
                (item.lotOption !== LOT_OPTIONS.SPECIFIC_LOTS || item.selectedLotIds?.length > 0)
            ) &&
            !data.pricing.pricingItems.some(item => item.isNew) &&
            !data.pricing.somePricingHasUnsavedEdits
    },
    {
        key: 3,
        stepKey: 'rules',
        title: 'Automation',
        subtitle: 'Configure mechanical rules',
        component: () => <BundleMechanicalRulesStep />,
        validate: (data) => data.rules?.rulesList?.length > 0 && !data.rules.rulesList.some(rule => rule.isNew) && !data.rules.someRuleHasUnsavedEdits
    },
    {
        key: 4,
        stepKey: 'summary',
        title: 'Summary',
        subtitle: 'Review and confirm',
        component: ({ onEditStep }) => <BundleSummaryStep onEditStep={onEditStep} />,
        validate: () => true
    }
];
